import cug from "../../services/cug";

// initial state
const state = {
  status: "",
  uuid: "",
  expired_at: "",
  items: []
};

// getters
const getters = {
  isCreated: state => {
    return !!state.uuid;
  },

  isExpirable: state => {
    return !!state.expired_at;
  },

  getUuid: state => {
    return state.uuid;
  },

  getItems: state => {
    return state.items;
  },

  getItemsCount: state => {
    return state.items.length;
  },

  getExpiryDate: state => {
    if (state.expired_at && state.expired_at !== "") {
      return state.expired_at;
    } else {
      return null;
    }
  }
};

// actions
const actions = {
  // Get cart
  async get({ commit }) {
    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .getCart()
        .then(resp => {
          commit("success", {
            uuid: resp.data.uuid,
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Create cart => return Uuid and Items
  async create({ commit }) {
    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .createCart()
        .then(resp => {
          commit("success", {
            uuid: resp.data.uuid,
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Delete cart
  delete({ commit }) {
    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .deleteCart()
        .then(resp => {
          commit("delete");
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Delete item
  deleteItem({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .deleteCartItem(data.uuidItem)
        .then(resp => {
          commit("itemDeleted", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Clear cart store
  clearCart({ commit }) {
    commit("clearCart");
  },

  // Find or create cart
  async findOrCreate({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      dispatch("get", data)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          if (err.response.status === 404) {
            dispatch("create", data)
              .then(resp => {
                resolve(resp);
              })
              .catch(err => {
                commit("error");
                reject(err);
              });
          } else {
            commit("error");
            reject(err);
          }
        });
    });
  },

  // Add planned lesson to cart
  async addPlannedLesson({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addPlannedLessonToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Add planned lesson to cart
  async addPlannedActivity({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addPlannedActivityToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Add subscription to cart
  async addSubscription({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addSubscriptionToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Add unlimited subscription to cart
  async addUnlimitedSubscription({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addUnlimitedSubscriptionToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Add tickets book to cart
  async addTicketsBook({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addTicketsBookToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Add tickets book to cart
  async addProduct({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addProductToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Add Planned Stages
  async addPlannedStages({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
          .addPlannedStagesToCard(data)
          .then(resp => {
            commit("itemAdded", {
              expired_at: resp.data.expired_at,
              items: resp.data.items
            });
            resolve(resp);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
    });
  },

  // Add tickets book to cart
  async addMultiTicketsBook({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
          .addMultiTicketsBookToCard(data)
          .then(resp => {
            commit("itemAdded", {
              expired_at: resp.data.expired_at,
              items: resp.data.items
            });
            resolve(resp);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
    });
  },

  // Add pack to cart
  async addPack({ commit, dispatch }, data) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .addPackToCard(data)
        .then(resp => {
          commit("itemAdded", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  async updatePack({ commit, dispatch }, { data, uuid }) {
    await dispatch("findOrCreate", data);

    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .updateCartPack(data, uuid)
        .then(resp => {
          commit("packUpdated", {
            expired_at: resp.data.expired_at,
            items: resp.data.items
          });
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  },

  // Checkout cart
  checkout({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("request");
      cug
        .checkoutCart(data)
        .then(resp => {
          commit("checkout");
          resolve(resp);
        })
        .catch(err => {
          commit("error");
          reject(err);
        });
    });
  }
};

// mutations
const mutations = {
  request(state) {
    state.status = "loading";
  },

  success(state, payload) {
    state.status = "success";
    state.uuid = payload.uuid;
    state.expired_at = payload.expired_at;
    state.items = payload.items;
  },

  itemAdded(state, payload) {
    state.status = "success";
    state.expired_at = payload.expired_at;
    state.items = payload.items;
  },

  itemDeleted(state, payload) {
    state.status = "success";
    state.expired_at = payload.expired_at;
    state.items = payload.items;
  },

  packUpdated(state, payload) {
    state.status = "success";
    state.expired_at = payload.expired_at;
    state.items = payload.items;
  },

  error(state) {
    state.status = "error";
  },

  delete(state) {
    state.status = "";
    state.expired_at = "";
    state.uuid = "";
    state.items = [];
  },

  checkout(state) {
    state.status = "";
    state.expired_at = "";
    state.uuid = "";
    state.items = [];
  },

  clearCart() {
    state.status = "";
    state.expired_at = "";
    state.uuid = "";
    state.items = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
